import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonView = ({
  isPhone,
  lengthMobile = 2,
  length = 3,
  flex = true,
  width = "ml:w-[350px]",
  padding = "px-4",
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (isPhone && mounted) {
    return (
      <div
        className={`${flex ? "gap-x-2 snap-x" : "flex-col gap-y-2 snap-y"} flex overflow-x-hidden snap-mandatory ${padding}`}
      >
        {Array.from({ length: lengthMobile }).map((_, i) => (
          <div
            key={i}
            className={`w-11/12 ${width} shrink-0 grow-0 basis-auto snap-start bg-white shadow-sm border border-gray-100 rounded-2xl overflow-hidden`}
          >
            <Skeleton height={208} containerClassName="flex" borderRadius={0} />
            <div className="p-4 border-b border-gray-100 flex justify-between">
              <div className="flex flex-col gap-1 w-2/3">
                <Skeleton height={18} width="80%" />
                <Skeleton height={12} width="50%" />
              </div>
              <div className="flex flex-col items-end gap-1 w-1/3 text-right">
                <Skeleton height={18} width="90%" />
                <Skeleton height={10} width="60%" />
              </div>
            </div>
            <div className="p-3 flex justify-between bg-gray-50/50">
              <div className="flex items-center gap-1.5">
                <Skeleton circle height={14} width={14} />
                <Skeleton height={10} width={20} />
              </div>
              <div className="flex items-center gap-1.5">
                <Skeleton circle height={14} width={14} />
                <Skeleton height={10} width={20} />
              </div>
              <div className="flex items-center gap-1.5">
                <Skeleton circle height={14} width={14} />
                <Skeleton height={10} width={20} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {Array.from({ length: length }).map((_, i) => (
        <div
          key={i}
          className={`${
            i === 3 ? "hidden xl:flex" : i === 2 ? "hidden md:flex" : "flex"
          } flex-col bg-white shadow-sm border border-gray-100`}
        >
          <Skeleton height={280} borderRadius={0} containerClassName="flex" />
          <div className="p-6 border-b border-gray-100 flex justify-between items-center">
            <div className="flex flex-col gap-2 w-1/2">
              <Skeleton height={24} width="80%" />
              <Skeleton height={16} width="60%" />
            </div>
            <div className="flex flex-col items-end gap-1 w-1/2 text-right">
              <Skeleton height={24} width="70%" />
              <Skeleton height={14} width="50%" />
            </div>
          </div>
          <div className="p-5 flex justify-between bg-gray-50/30">
            <div className="flex items-center gap-2">
              <Skeleton circle height={20} width={20} />
              <Skeleton height={14} width={30} />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton circle height={20} width={20} />
              <Skeleton height={14} width={30} />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton circle height={20} width={20} />
              <Skeleton height={14} width={30} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonView;
